import { CubeTimeDimensionGranularity } from '../enum/cube-time-dimension-granularity.enum';
import { AppGoalsCubeMetric } from '../enum/goal/app-goals-cube-metrics.enum';
import { IGoalOperator } from '../enum/goal/goal-operator.enum';
import { CoreScoreNames } from '../enum/scores/core-score-name.enum';

export class GoalDto {
  startDate: string;
  endDate: string;
  scoreName?: CoreScoreNames;
  period: CubeTimeDimensionGranularity;
  operator: IGoalOperator;
  value: string;
  appId?: string;
  measure?: AppGoalsCubeMetric;
  appCategoryId?: string;
}
